import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import "./PasswordInput.css";

/**
 * Input de contraseña con el ojito para verla. Reemplaza cualquier
 * <input type="password">: acepta las mismas props (className, style, value,
 * onChange, autoComplete, disabled…) y solo agrega el botón de mostrar/ocultar.
 * El botón queda fuera del tab order para no estorbar al escribir con Enter.
 */
export default function PasswordInput({ style, wrapClassName = "", ...inputProps }) {
  const [show, setShow] = useState(false);
  return (
    <span className={`pw-wrap ${wrapClassName}`}>
      <input {...inputProps} type={show ? "text" : "password"} style={{ ...(style || {}), paddingRight: "2.8rem" }} />
      <button
        type="button"
        className="pw-eye"
        tabIndex={-1}
        onClick={() => setShow((v) => !v)}
        aria-label={show ? "Ocultar contraseña" : "Mostrar contraseña"}
        title={show ? "Ocultar contraseña" : "Mostrar contraseña"}
      >
        {show ? <EyeOff size={18} /> : <Eye size={18} />}
      </button>
    </span>
  );
}
